import { render, staticRenderFns } from "./IotFaultsItem.vue?vue&type=template&id=8dd1cf56"
import script from "./IotFaultsItem.vue?vue&type=script&lang=js"
export * from "./IotFaultsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports